export default __webpack_public_path__ + "static/media/Testimonal.39105d5b.mp4";